import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({ selector: 'ng-template[typedTemplate]' })
export class TypedTemplateDirective<TypeToken> {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('typedTemplate') typeToken: TypeToken;

  constructor(private contentTemplate: TemplateRef<TypeToken>) {
  }

  // eslint-disable-next-line @typescript-eslint/no-shadow
  static ngTemplateContextGuard<TypeToken>(dir: TypedTemplateDirective<TypeToken>, ctx: unknown): ctx is TypeToken {
    return true;
  }
}
